/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer } from '@coursera/cds-core';

type Props = {
  children: React.ReactNode;
};

export const AiProgramBuilderWizardPageContainer = (props: Props): React.ReactElement => {
  const { children, ...otherProps } = props;

  return (
    <PageGridContainer>
      <Grid
        item
        xs={12}
        css={css`
          margin: 0 auto;
          box-sizing: content-box;
          max-width: 858px;
        `}
        {...otherProps}
      >
        {children}
      </Grid>
    </PageGridContainer>
  );
};

export default AiProgramBuilderWizardPageContainer;
